// styles
import styles from './assess-health-graph.module.scss'

type AssessHealthGraphProps = {
	readonly score?: number
}

const AssessHealthGraph = ({
	score = 0,
}: AssessHealthGraphProps): JSX.Element => {
	const zone = Math.ceil(((score === 0 ? 1 : score) / 10) * 6)

	return (
		<div className={styles.assessHealthGraph} data-zone={zone}>
			<div className={styles.score}></div>
			<svg
				viewBox="0 0 317 160"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={styles.graph}
			>
				<g>
					<path
						d="M19.2706 82.4329L84.1117 117.399C90.5683 105.678 99.7243 95.6481 110.742 88.1452L70.857 26.3315C49.4159 40.5464 31.6438 59.8144 19.2595 82.4439L19.2706 82.4329Z"
						fill="#82B230"
					/>
					<path
						d="M0 158H73.6997C73.6997 144.455 76.9169 131.669 82.5912 120.321L17.717 85.344C6.40148 107.095 0 131.8 0 158Z"
						fill="#50B233"
					/>
					<path
						d="M160.147 0V73.5019C176.74 73.8205 192.155 78.8737 205.101 87.3872L244.975 25.5735C220.548 9.66697 191.438 0.31857 160.147 0Z"
						fill="#FFAF2E"
					/>
					<path
						d="M73.6336 24.5189L113.519 86.3436C126.123 78.4672 140.943 73.8095 156.842 73.5019V0C126.245 0.307585 97.73 9.26052 73.6336 24.5189Z"
						fill="#F6E64F"
					/>
					<path
						d="M317 158C317 132.855 311.094 109.083 300.616 87.9695L235.687 122.979C240.568 133.646 243.3 145.499 243.3 157.989H317V158Z"
						fill="#C92828"
					/>
					<path
						d="M247.741 27.397L207.833 89.2546C218.95 97.1969 228.051 107.743 234.255 120.013L299.118 85.0363C286.987 61.8575 269.27 42.0512 247.741 27.397Z"
						fill="#EB4B1E"
					/>
				</g>
			</svg>
			<div className={styles.needle}>
				<svg viewBox="0 0 29 78" xmlns="http://www.w3.org/2000/svg">
					<path
						fill="none"
						stroke="#000000"
						strokeWidth="5"
						d="M 20.166039 57.550354 C 24.501335 60.505539 25.620132 66.415649 22.664948 70.750938 C 19.709759 75.086235 13.799656 76.205032 9.464359 73.249847 C 5.129066 70.294662 4.010269 64.384552 6.965454 60.049259 C 9.920643 55.713966 15.830746 54.595169 20.166039 57.550354 Z"
					/>
					<path
						fill="#090909"
						stroke="none"
						d="M 8.731371 55.881096 L 14.873587 1.925446 L 20.731087 55.970722 L 8.731371 55.881096 Z"
					/>
				</svg>
			</div>
		</div>
	)
}

export default AssessHealthGraph
